module.exports = __webpack_public_path__ + "static/pic06-096ecb794990bd89aa814411d0c9f084.jpg";